export default __webpack_public_path__ + "static/media/verticalEllipsis.svg";